// extracted by mini-css-extract-plugin
export default {"container":"U-X6bD6dgTdRhsDXbiydM"};